export interface CheckboxProps {
  field: string
  label?: string
  required?: boolean
  onChange: (field: string, checked: boolean, isValid: boolean) => void
  className?: string
  revalidate: boolean
}

export type CheckboxState = {
  checked: boolean
  isValid: boolean
  touched: boolean
}

export enum ActionTypes {
  CHECKBOX_CHANGE = 'CHECKBOX_CHANGE',
  CHECKBOX_BLUR = 'CHECKBOX_BLUR',
}

type CheckboxChangeType = {
  type: typeof ActionTypes.CHECKBOX_CHANGE
  checked: boolean
  isValid: boolean
}

type CheckboxBlurType = {
  type: typeof ActionTypes.CHECKBOX_BLUR
}

export type CheckboxActionTypes = CheckboxChangeType | CheckboxBlurType
